// ツールタイプ
export type EditorTool =
  | 'select'      // 選択・移動
  | 'text'        // テキスト
  | 'marker'      // マーカー
  | 'horizontal'  // 水平線
  | 'rectangle';  // 四角形（塗りつぶし/枠線オプション付き）

// 編集オブジェクトの型
export interface EditorObject {
  id: string;
  type: 'text' | 'rect' | 'line' | 'marker' | 'band' | 'image';
  x: number;
  y: number;
  text?: string;
  fontSize?: number;
  fontFamily?: string;
  fontStyle?: 'normal' | 'bold' | 'italic';
  textAlign?: 'left' | 'center' | 'right' | 'justify';
  verticalAlign?: 'top' | 'middle' | 'bottom';
  textColor?: string;        // 文字色（テキスト・四角形共通）
  backgroundColor?: string;  // 背景色（テキスト・四角形共通）
  width?: number;
  height?: number;
  stroke?: string;           // 枠線色
  strokeWidth?: number;      // 枠線太さ
  points?: number[];
  imageUrl?: string;
  rotation?: number;
}

// 表示サイズ
export interface DisplaySize {
  width: number;
  height: number;
  offsetX: number;
  offsetY: number;
}

// キャンバスサイズ
export interface CanvasSize {
  width: number;
  height: number;
}

// コンテンツ境界
export interface ContentBounds {
  x: number;
  y: number;
  width: number;
  height: number;
}

// ユニークID生成
export const generateId = () => `obj_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
